/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { tokenService } from 'services/Token'
import { analytics, PAGE_CONTENT_TYPES } from 'services/Analytics'
import { ROUTES } from 'constants/routes'
import { USER_LOGOUT_ACTION } from 'constants/user'
import { REGISTRATION_STEPS } from 'constants/auth'
import { onShowError } from 'redux-app/modules/alerts'
import { getSelectedPlanId } from 'redux-app/selectors/subscription'
import {
  refresh,
  login,
  signUp,
  forgotPassword,
  resetPassword,
  completeInitialSubscription,
} from 'api/client/actions/auth'
import { getUserDetails } from 'api/client/actions/user'
import { verifyCurrentCard } from 'api/client/actions/card'
import { IState } from 'redux-app/types/auth'
import { 
  isUserAbleToOpenProfile, 
  isUserNeedsToRenewSubscription, 
  getUserDetails as userDetailsState 
} from 'redux-app/selectors/user'
import { loadingWrapper } from 'redux-app/utils/loadingWrapper'
import { handlePromiseActions, createModuleAction } from 'redux-app/utils/reducer'
import { history } from 'utils/location'
import { getSignInStep } from 'utils/user'

const createAction = createModuleAction('AUTH')

const update = createAction('UPDATE')
export const updateUserRole = createAction('UPDATE_USER_ROLE')
export const updateRegistrationStep = createAction('UPDATE_REGISTRATION_STEP')
const clearError = createAction('CLEAR_ERROR')

export const onLogin = ({ email, password, captcha }) => (dispatch, getState) => {
  const formValues = { username: email, password, googleRecaptchaResponse: captcha }
  return dispatch(login(formValues))
    .then(({ value: { result: { access_token: accessToken } } }) => {
      const { role } = tokenService.getTokenPayload(accessToken)

      return dispatch(getUserDetails())
        .then(({ value: { result: userDetails } }) => {

          if (!userDetails.emailConfirmed)
          {
            return userDetails
          }

          dispatch(updateRegistrationStep(getSignInStep(userDetails)))

          analytics.login({ userId: userDetails.userId, contentType: PAGE_CONTENT_TYPES.login })
          dispatch(update({
            token: {
              role,
            },
          }))
        })
    })
    .then(() => {

      var isEmailConfirmed = userDetailsState(getState()).emailConfirmed
      if (isEmailConfirmed)
      {
        if (isUserNeedsToRenewSubscription(getState())) {
          dispatch(verifyCurrentCard()).then(({ value: { result } }) => {
            history.push(ROUTES.profile.renewPlan.root)
            return
          })
          .catch(error => {
            onShowError(error)
          })
        }
        else if (isUserAbleToOpenProfile(getState())) {
          history.push(ROUTES.profile.view)
        } else {
          history.push(ROUTES.profile.create)
        }
      }
    })
}

export const onSignUp = ({
   email,
   password,
   captcha,
}) =>
(dispatch, getState) => {
  const state = getState()
  const body = {
    email,
    password,
    googleRecaptchaResponse: captcha,
    subscriptionPlanId: getSelectedPlanId(state),
  }
  return dispatch(signUp(body))
    .then(({ value: { result } }) => {
    })
}

export const onForgotPassword = ({ email, captcha }) =>
    dispatch => dispatch(forgotPassword({ email, googleRecaptchaResponse: captcha }))

export const onResetPassword = formValues => dispatch => dispatch(resetPassword(formValues))

export const onSaveInitialSubscription = ({
  userId,
  billingAddress,
  company,
  shippingAddress,
  creditCard,
}) => dispatch => {
  return dispatch(completeInitialSubscription({
    userId,
    billingAddress,
    company,
    shippingAddress,
    creditCard,
  }))
}

export const onCompleteInitialSubscription = () => dispatch => {
  return dispatch(getUserDetails()).then(() => {
    dispatch(updateRegistrationStep(REGISTRATION_STEPS.terms))
  })
}

const ACTION_HANDLERS = {
  [update]: (state, { payload }) => ({
    ...state,
    token: {
      ...state.token,
      value: {
        ...state.token.value,
        ...payload.token,
      },
    },
  }),
  [refresh.toString()]: loadingWrapper('token', [
    null,
    (state, { payload: { result } }) => ({
      access: result.access_token,
      refresh: result.refresh_token,
    }),
    state => ({
      ...state.token.value,
      access: null,
      refresh: null,
      role: null,
    }),
  ]),
  [login.toString()]: loadingWrapper('token', [
    null,
    (state, { payload: { result } }) => ({
      access: result.access_token,
      refresh: result.refresh_token,
    }),
    state => ({
      ...state.token.value,
      access: null,
      refresh: null,
      role: null,
    }),
  ]),
  [updateUserRole.toString()]: (state, { payload }) => ({
    ...state,
    token: {
      ...state.token,
      value: {
        ...state.token.value,
        role: payload,
      },
    },
  }),
  [USER_LOGOUT_ACTION]: state => ({
    ...state,
    token: {
      loaded: false,
      loading: false,
      value: null,
    },
    registrationStep: null,
  }),
  [clearError]: state => ({
    ...state,
    error: null,
  }),
  [updateRegistrationStep.toString()]: (state, { payload }) => ({
    ...state,
    registrationStep: payload,
  }),
}

const initialState: IState = {
  token: {
    value: {
      role: null,
    },
  },
  error: null,
  registrationStep: null,
}

export default handlePromiseActions(ACTION_HANDLERS, initialState)
